import Menu from '@/data/sidebar.json';

export default {
  menus: Menu.menus,
}
